import { render } from "./Homeicon.vue?vue&type=template&id=a3681896&scoped=true"
import script from "./Homeicon.vue?vue&type=script&lang=js"
export * from "./Homeicon.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a3681896"

export default script